var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14719 11.3749C6.14575 10.3372 6.3497 9.30943 6.74732 8.35088C7.14493 7.39233 7.72832 6.52196 8.46388 5.78993C9.19944 5.05791 10.0726 4.4787 11.0331 4.08571C11.9935 3.69272 13.0222 3.49371 14.06 3.50015C18.3901 3.53234 21.8536 7.13155 21.8536 11.4738V12.2499C21.8536 16.1673 22.6732 18.4404 23.3951 19.6829C23.4728 19.8156 23.5142 19.9665 23.515 20.1204C23.5159 20.2742 23.4761 20.4256 23.3998 20.5591C23.3234 20.6927 23.2132 20.8038 23.0802 20.8812C22.9473 20.9586 22.7962 20.9995 22.6424 20.9999H5.35757C5.2037 20.9995 5.05266 20.9586 4.91968 20.8812C4.7867 20.8038 4.67649 20.6926 4.60016 20.559C4.52383 20.4254 4.48409 20.2741 4.48494 20.1202C4.48579 19.9663 4.5272 19.8154 4.605 19.6827C5.32724 18.4402 6.14719 16.1671 6.14719 12.2499L6.14719 11.3749Z",
    stroke: "#3082F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21V21.875C10.5 22.8033 10.8687 23.6935 11.5251 24.3499C12.1815 25.0063 13.0717 25.375 14 25.375C14.9283 25.375 15.8185 25.0063 16.4749 24.3499C17.1313 23.6935 17.5 22.8033 17.5 21.875V21",
    stroke: "#3082F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.07bf3ab4e75035a3b67e7c2eba43f784.svg";
export { ForwardRef as ReactComponent };